<template>
  <div class="prog">
    <div class="row">
      <div class="col-12">
        <h1 class="trilha_titulo justify-content-center">
          Escolha suas trilhas
        </h1>
        <h1 class="trilha_titulo-res justify-content-center">
          Selecione sua trilha preferida
        </h1>
      </div>
      <div class="col-12">
        <div class="trilhas">
          <ul class="justify-content-center d-flex">
            <li
              v-for="trilha in trilhas"
              :key="trilha.nome"
              :id="trilha.id"
              @click="click(trilha.id)"
              class="align-items-center justify-content-center d-flex"
              style="color: white"
            >
              <p>{{ trilha.nome }}</p>
              <div :id="'divTrilha' + trilha.id"></div>
            </li>
          </ul>
        </div>
        <div class="trilhas-res align-items-center justify-content-center">
          <div class="select-fundo"></div>
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
          <select
            class="align-items-center justify-content-center"
            id="select_mobile"
            @change="selectMobile()"
          >
            <option id="0">Todas</option>
            <option
              v-for="trilha in trilhas"
              :key="trilha.nome"
              :id="trilha.id"
            >
              {{ trilha.nome }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12">
        <h1 class="justify-content-center d-flex">Selecione o dia</h1>
        <div class="datas">
          <ul class="justify-content-center d-flex" id="bloco-data">
            <li
              v-for="(day, index) in days"
              :key="index"
              class="branco"
              :class="index == 0 ? 'ativo-data' : ''"
              :id="'liDay' + index"
              @click="mudaData(index)"
            >
              <p class="p-day align-items-center justify-content-center">
                Day 0{{ index + 1 }} | {{ day }}
              </p>
              <div class="bloco-p align-items-center justify-content-center">
                <p class="p-day-res">Day 0{{ index + 1 }}</p>
                <p class="p-day-res">{{ day }}</p>
              </div>
              <div
                :id="'day' + index"
                class="branco2"
                :class="index == 0 ? 'blue-data' : ''"
              ></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <div class="alinhar align-items-center d-flex justify-content-center">
          <div
            v-for="(palest, idx) in filtrarPalestrantes(palestras)"
            :key="idx"
            class="
              palestras
              col-12 col-lg-6 col-xl-4
              align-items-center
              d-flex
              justify-content-center
            "
          >
            <div
              v-if="palest.palestrantes.length > 1"
              class="background-palestras"
              style="
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                background-image: url(img/bg-prog.png);
                padding: 20px 30px 20px 30px;
              "
              @click="
                abreModal(
                  palest.palestrantes[0].img,
                  palest.palestrantes[0].nome_palestrante,
                  palest.palestrantes[0].minibio,
                  palest.palestrantes[0].empresa,
                  palest.data,
                  palest.palestrantes[0].palestrante_descricao,
                  palest.palestra_descricao,
                  palest.trilhaNome,
                  palest.plenaria,
                  palest.cor,
                  palest.palestrantes[0].linkedin,
                  palest.corTexto_plenaria,
                  palest.palestrantes,
                  palest.nome_palestra,
                  palest.hora_inicio,
                  palest.hora_fim,
                  palest.cor_plenaria,
                  palest.trilhas
                )
              "
            >
              <div class="bloco-plenaria">
                <div class="azul-palestrante-plenaria"></div>
                <div
                  class="plenaria-palestrante"
                  :style="
                    'background-color:' +
                    palest.cor_plenaria +
                    ';color:' +
                    palest.corTexto_plenaria
                  "
                >
                  {{ palest.plenaria }}
                </div>
              </div>
              <div class="row" style="padding: 10px">
                <div
                  class="
                    palestrantes_bloco_painel
                    col-12 col-lg-12
                    d-flex
                    justif-content-center
                    align-items-center
                  "
                  v-for="(itemPale, indexPale) in palest.palestrantes"
                  :key="indexPale"
                  style="position: relative; padding: 10px; margin-bottom: 10px"
                >
                  <div class="image_area">
                    <div class="img-azul-small"></div>
                    <div
                      class="img-palestrante-small"
                      :style="'background-image:url(' + itemPale.img + ')'"
                      style="
                        background-repeat: no-repeat;
                        background-size: contain;
                        background-position: center;
                      "
                    ></div>
                  </div>
                  <div class="info-palestrante-small">
                    <p class="destaque-rosa">
                      {{ itemPale.nome_palestrante }}
                    </p>
                    <p class="destaque">{{ itemPale.empresa }}</p>
                  </div>
                </div>
              </div>
              <p
                class="titulo_palestra"
                style="margin-top: -10px"
                v-if="
                  palest.palestrantes.length > 3 &&
                  palest.nome_palestra.length > 85
                "
              >
                {{ palest.nome_palestra.substr(0, 85) + "..." }}
              </p>
              <p
                class="titulo_palestra"
                style="margin-top: -10px"
                v-else-if="palest.palestrantes.length > 3"
              >
                {{ palest.nome_palestra }}
              </p>
              <p
                class="titulo_palestra"
                style="margin-top: -10px"
                v-if="
                  palest.palestrantes.length <= 3 &&
                  palest.nome_palestra.length > 150
                "
              >
                {{ palest.nome_palestra.substr(0, 150) + "..." }}
              </p>
              <p
                class="titulo_palestra"
                style="margin-top: -10px"
                v-else-if="palest.palestrantes.length <= 3"
              >
                {{ palest.nome_palestra }}
              </p>
              <div class="plenaria-hora">
                <p>
                  {{ palest.hora_inicio.substr(0, 5) }} -
                  {{ palest.data.substr(0, 5) }}
                </p>
              </div>
              <div class="alinhar-botoes">
                <div class="row alinhar-trilha">
                  <div
                    class="col-6"
                    v-for="(trilha, index) in palest.trilhas"
                    :key="index"
                    style="
                      position: relative;
                      margin-right: -20px;
                      margin-bottom: 10px;
                    "
                  >
                    <div class="azul-palestrante1"></div>
                    <div
                      class="trilha-palestrante"
                      :style="
                        'background-color:' +
                        trilha.cor +
                        ';color:' +
                        trilha.corTexto
                      "
                    >
                      {{ trilha.trilhaNome }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="background-palestras"
              style="
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                background-image: url(img/bg-prog.png);
                padding: 30px;
              "
              @click="
                abreModal(
                  palest.palestrantes[0].img,
                  palest.palestrantes[0].nome_palestrante,
                  palest.palestrantes[0].minibio,
                  palest.palestrantes[0].empresa,
                  palest.data,
                  palest.palestrantes[0].palestrante_descricao,
                  palest.palestra_descricao,
                  palest.trilhaNome,
                  palest.plenaria,
                  palest.cor,
                  palest.palestrantes[0].linkedin,
                  palest.corTexto_plenaria,
                  palest.palestrantes,
                  palest.nome_palestra,
                  palest.hora_inicio,
                  palest.hora_fim,
                  palest.cor_plenaria,
                  palest.trilhas
                )
              "
            >
              <div class="bloco-plenaria">
                <div class="azul-palestrante-plenaria"></div>
                <div
                  class="plenaria-palestrante"
                  :style="
                    'background-color:' +
                    palest.cor_plenaria +
                    ';color:' +
                    palest.corTexto_plenaria
                  "
                >
                  {{ palest.plenaria }}
                </div>
              </div>
              <div
                style="display: flex; flex-direction: row; min-height: 125px"
              >
                <div style="position: relative">
                  <div class="img-azul"></div>
                  <div
                    v-if="palest.palestrantes[0]"
                    class="img-palestrante"
                    :style="
                      'background-image:url(' + palest.palestrantes[0].img + ')'
                    "
                    style="
                      background-repeat: no-repeat;
                      background-size: contain;
                      background-position: center;
                    "
                  ></div>
                </div>
                <div class="info-palestrante">
                  <p class="destaque-rosa">
                    {{
                      palest.palestrantes[0]
                        ? palest.palestrantes[0].nome_palestrante
                        : ""
                    }}
                  </p>
                  <p class="destaque">
                    {{
                      palest.palestrantes[0]
                        ? palest.palestrantes[0].empresa
                        : ""
                    }}
                  </p>
                  <p class="minibio">
                    {{
                      palest.palestrantes[0]
                        ? palest.palestrantes[0].minibio
                        : ""
                    }}
                  </p>
                </div>
              </div>
              <p
                class="titulo_palestra"
                v-if="palest.nome_palestra.length > 150"
                style="margin-top: 20px"
              >
                {{ palest.nome_palestra.substr(0, 150) + "..." }}
              </p>
              <p class="titulo_palestra" style="margin-top: 20px" v-else>
                {{ palest.nome_palestra }}
              </p>
              <div class="plenaria-hora">
                <p>
                  {{ palest.hora_inicio.substr(0, 5) }} -
                  {{ palest.data.substr(0, 5) }}
                </p>
              </div>
              <div class="alinhar-botoes">
                <div class="row alinhar-trilha">
                  <div
                    class="col-6"
                    v-for="(trilha, index) in palest.trilhas"
                    :key="index"
                    style="
                      position: relative;
                      margin-right: -20px;
                      margin-bottom: 10px;
                    "
                  >
                    <div class="azul-palestrante1"></div>
                    <div
                      class="trilha-palestrante"
                      :style="
                        'background-color:' +
                        trilha.cor +
                        ';color:' +
                        trilha.corTexto
                      "
                    >
                      {{ trilha.trilhaNome }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showModal"
      class="modal-prog align-items-center d-flex justify-content-center"
    >
      <div
        class="
          modal-preto-prog
          align-items-center
          justify-content-center
          d-flex
        "
        @click="showModal = false"
        @click.prevent="ativaScroll()"
      ></div>
      <div class="modal-azul-prog">
        <div class="modal-branco-prog">
          <i
            class="fa fa-times"
            aria-hidden="true"
            @click="showModal = false"
            @click.prevent="ativaScroll()"
          ></i>
          <div class="bloco-plenaria">
            <div class="azul-palestrante-plenaria"></div>
            <div
              class="plenaria-palestrante"
              :style="
                'background-color:' +
                this.palestrante.cor_plenaria +
                ';color:' +
                this.palestrante.corTexto_plenaria
              "
            >
              {{ this.palestrante.plenaria }}
            </div>
          </div>
          <div v-if="this.modalPalestrantes.length > 1">
            <div
              class="info-modal info-modalDois"
              v-for="(item, index) in this.modalPalestrantes"
              :key="index"
            >
              <div
                style="position: relative"
                class="align-items-center d-flex justify-content-center"
              >
                <div class="img-azul modaldois-img modal-img-azul-dois"></div>
                <div
                  class="img-palestrante modaldois-img"
                  :style="'background-image:url(' + item.img + ')'"
                  style="
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;
                  "
                ></div>
              </div>
              <div class="info-palestrante res-info">
                <p class="destaque-rosa">
                  {{ item.nome_palestrante }}
                </p>
                <p class="destaque">{{ item.empresa }}</p>                
                <a :href="item.linkedin" v-if="item.linkedin" target="_blank">
                  <div
                    class="
                      linkedin
                      modal-linkedin
                      align-items-center
                      justify-content-center
                      d-flex
                    "
                  >
                    <img src="img/linkedin.png" />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="info-modal">
              <div
                style="position: relative"
                class="align-items-center d-flex justify-content-center"
              >
                <div class="img-azul modal-img modal-img-azul"></div>
                <div
                  class="img-palestrante modal-img"
                  :style="'background-image:url(' + this.palestrante.img + ')'"
                  style="
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;
                  "
                ></div>
              </div>
              <div class="info-palestrante res-info">
                <p class="destaque-rosa">
                  {{ this.palestrante.nome_palestrante }}
                </p>
                <p class="destaque">{{ this.palestrante.empresa }}</p>
                <!-- <p class="minibio">{{ this.palestrante.minibio}}</p> -->
                <a
                  :href="this.palestrante.linkedin"
                  v-if="this.palestrante.linkedin"
                  target="_blank"
                >
                  <div
                    class="
                      linkedin
                      modal-linkedin
                      align-items-center
                      justify-content-center
                      d-flex
                    "
                  >
                    <img src="img/linkedin.png" />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div>
            <div class="descricao_modal" style="text-align: left">
              <h5>{{ this.nomeDaPalestra }}</h5>
            </div>
          </div>
          <div class="plenaria-hora">
            <p>
              {{ this.palestrante.hora_inicio.substr(0, 5) }} -
              {{ this.palestrante.data.substr(0, 5) }}
            </p>
          </div>
          <div v-if="this.modalPalestrantes.length > 1">
            <div
              class="descricao_modal"
              v-for="(item, index) in this.modalPalestrantes"
              :key="index"
            >
              <h5>Bio ({{item.nome_palestrante}}):</h5>
              <p>{{ item.palestrante_descricao }}</p>
            </div>
          </div>
          <div v-else>
            <div
              class="descricao_modal"
              v-if="this.palestrante.palestranteDescricao"
            >
              <h5>Bio:</h5>
              <p>{{ this.palestrante.palestranteDescricao }}</p>
            </div>
          </div>
          <div
            class="descricao_modal"
            v-if="this.palestrante.palestraDescricao"
          >
            <h5>Conteúdo abordado:</h5>
            <p>{{ this.palestrante.palestraDescricao }}</p>
          </div>
          <div class="alinhar-botoes">
            <div class="row align-items-center d-flex justify-content-center">
              <div
                class="col-12 col-md-6"
                v-for="(trilha, index) in this.palestrante.trilhas"
                :key="index"
                style="
                  position: relative;
                  margin-right: -20px;
                  margin-bottom: 10px;
                "
              >
                <div class="azul-palestrante1-modal1"></div>
                <div
                  class="trilha-palestrante-modal1"
                  :style="
                    'background-color:' +
                    trilha.cor +
                    ';color:' +
                    trilha.corTexto
                  "
                >
                  {{ trilha.trilhaNome }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["palestras", "trilhas", "days"],
  data() {
    return {
      selected: [],
      filtros_trilhas: [],
      data_selecionada: 0,
      showModal: false,
      showModalDois: false,
      palestrante: {
        img: "",
        nome_palestrante: "",
        minibio: "",
        empresa: "",
        data: "",
        palestranteDescricao: "",
        palestraDescricao: "",
        cor: "",
        plenaria: "",
        trilha: "",
        linkedin: "",
        corTexto: "",
        nomeDaPalestra: "",
        hora_inicio: "",
        hora_fim: "",
        cor_plenaria: "",
        trilhas: [],
        corTexto_plenaria: "",
      },
      modalPalestrantes: [],
    };
  },
  mounted() {},
  created() {
    var palestras = this.palestras;
    for (let i = 0; i < palestras.length; i++) {
      const element = palestras[i];
      element.corTexto_plenaria = this.mudaCor(element.cor_plenaria);
      for (let i = 0; i < element.trilhas.length; i++) {
        const trilha = element.trilhas[i];
        trilha.corTexto = this.mudaCor(trilha.cor);
      }
    }
  },
  methods: {
    abreModal(
      img,
      nome,
      minibio,
      empresa,
      data,
      palestranteDescricao,
      palestraDescricao,
      trilha,
      plenaria,
      cor,
      linkedin,
      corTexto_plenaria,
      palestrantes,
      nomeDaPalestra,
      hora_inicio,
      hora_fim,
      cor_plenaria,
      trilhas
    ) {
      this.showModal = true;
      this.palestrante.img = img;
      this.palestrante.nome_palestrante = nome;
      this.palestrante.minibio = minibio;
      this.palestrante.empresa = empresa;
      this.palestrante.data = data;
      this.palestrante.palestranteDescricao = palestranteDescricao;
      this.palestrante.palestraDescricao = palestraDescricao;
      this.palestrante.trilha = trilha;
      this.palestrante.plenaria = plenaria;
      this.palestrante.cor = cor;
      this.palestrante.linkedin = linkedin;
      this.modalPalestrantes = palestrantes;
      this.nomeDaPalestra = nomeDaPalestra;
      this.palestrante.hora_inicio = hora_inicio;
      this.hora_fim = hora_fim;
      this.palestrante.cor_plenaria = cor_plenaria;
      this.palestrante.trilhas = trilhas;
      this.palestrante.corTexto_plenaria = corTexto_plenaria;
      document.getElementById("html").style.overflow = "hidden";
      console.log(this.palestrante.hora_inicio);
    },
    ativaScroll() {
      document.getElementById("html").style.overflow = "scroll";
      document.getElementById("html").style.overflowX = "hidden";
    },
    mudaCor(hexcolor) {
      if (hexcolor.slice(0, 1) === "#") {
        hexcolor = hexcolor.slice(1);
      }
      if (hexcolor.length === 3) {
        hexcolor = hexcolor
          .split("")
          .map(function (hex) {
            return hex + hex;
          })
          .join("");
      }
      let r = parseInt(hexcolor.substr(0, 2), 16);
      let g = parseInt(hexcolor.substr(2, 2), 16);
      let b = parseInt(hexcolor.substr(4, 2), 16);
      let yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? "black" : "white";
    },
    selectMobile() {
      var e = document.getElementById("select_mobile");
      this.selected = [];
      this.selected.push(+e.options[e.selectedIndex].id);
    },
    click(id) {
      if (this.verificaClass(id)) {
        document.getElementById(id).classList.remove("ativo");
        document.getElementById("divTrilha" + id).classList.remove("blue");
        const index = this.selected.indexOf(id);
        if (index > -1) {
          this.selected.splice(index, 1);
        }
      } else {
        document.getElementById(id).classList.add("ativo");
        document.getElementById("divTrilha" + id).classList.add("blue");
        this.selected.push(id);
      }
    },
    verificaClass(id) {
      var pai = document.getElementById(id);
      if (pai.classList.contains("ativo")) {
        return true;
      } else {
        return false;
      }
    },
    mudaData(li) {
      var ativo = document.getElementsByClassName("ativo-data");
      var azul = document.getElementsByClassName("blue-data");
      for (let i = 0; i < ativo.length; i++) {
        const element = ativo[i];
        element.classList.remove("ativo-data");
      }
      azul[0].classList.remove("blue-data");
      document.getElementById("liDay" + li).classList.add("ativo-data");
      document.getElementById("day" + li).classList.add("blue-data");
      this.data_selecionada = li;
    },

    filtrarPalestrantes(dados) {
      dados = dados.filter(
        (item) =>
          item.data_filtro.toLowerCase() ==
          this.days[this.data_selecionada].toLowerCase()
      );
      console.log("recebidos:", dados);

      if (this.selected.length > 0 && this.selected[0] != 0) {
        dados = dados.filter((item) => {
          const f = item.trilhas.filter((elem) =>
            this.selected.includes(elem.trilhaId)
          );
          if (f.length > 0) {
            return true;
          }
          return false;
        });
      }
      return dados;
    },

    separarObjeto(objeto, key) {
      let novo_objeto = [];
      objeto.forEach((element, index) => {
        novo_objeto[index] = element[key];
      });
      return novo_objeto;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "resources/assets/sass/website/_variables.scss";
.bloco-plenaria {
  margin-bottom: 10px;
  .plenaria-palestrante {
    align-items: center;
    border: 2px solid black;
    justify-content: center;
    font-weight: bold;
    display: flex;
    height: 30px;
    width: 180px;
    margin-top: -34px;
  }
  .azul-palestrante-plenaria {
    height: 30px;
    width: 180px;
    border: 2px solid black;
    background-color: #00faff;
    margin-left: 5px;
  }
}
.alinhar-trilha {
  position: absolute;
  bottom: 20px;
  left: 20px;
  @media (max-width: 996px) {
    bottom: 0px;
    left: -10px;
  }
}
.titulo_palestra {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0px;
  text-align: left;
  line-height: 15px;
}
.plenaria-hora {
  text-align: left;
  font-size: 15px;
  p {
    color: #ff006f !important;
  }
  span {
    font-weight: bold;
    font-style: italic;
  }
}
.hora {
  display: flex;
  flex-direction: row;
}
.alinhar-centro {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.trilha_titulo {
  display: flex;
  @media (max-width: 756px) {
    display: none;
  }
}
.trilha_titulo-res {
  display: none;
  @media (max-width: 756px) {
    display: flex;
  }
}
.trilhas-res {
  display: none;
  @media (max-width: 756px) {
    display: flex;
  }
  .fa {
    color: black;
    position: absolute;
    right: 30px;
    top: 15px;
    z-index: 1;
    @media (max-width: 576px) {
      right: 60px;
    }
  }
  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: #ff006f;
    border: 3px solid black;
    color: white;
    font-weight: bold;
    position: relative;
    padding-left: 20px;
    width: 100%;
    height: 50px;
    @media (max-width: 576px) {
      width: 90%;
    }
  }
  select::focus-visible {
    outline: none;
    box-shadow: none;
  }
  select::focus {
    outline: none;
    box-shadow: none;
  }
  .select-fundo {
    background-color: #00faff;
    border: 3px solid black;
    width: 92%;
    height: 95%;
    position: absolute;
    left: 37px;
    top: 10px;
    @media (max-width: 576px) {
      left: 57px;
      width: 84%;
    }
    @media (max-width: 450px) {
      left: 45px;
    }
    @media (max-width: 380px) {
      left: 35px;
    }
  }
}
.prog {
  .trilhas {
    @media (max-width: 756px) {
      display: none;
    }
  }
  h1 {
    color: white;
    font-family: "Montserrat", "sans-serif";
    font-size: 30px;
    font-weight: bold;
    margin-top: 50px;
    margin-bottom: 30px;
    @media (max-width: 575px) {
      font-size: 24px;
    }
    @media (max-width: 400px) {
      font-size: 18px;
    }
  }
  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    @media (max-width: 575px) {
      padding: 10px;
    }
    @media (max-width: 350px) {
      margin-left: -15px;
    }
  }
  li {
    padding: 10px;
    font-family: "Montserrat", "sans-serif";
    font-weight: 400;
    font-size: 20px;
    list-style: none;
    height: 40px;
    border: 3px solid transparent;
    margin-left: 20px;
    margin-bottom: 10px;
    position: relative;
    user-select: none;
    cursor: pointer;
    @media (max-width: 756px) {
      font-size: 18px;
      margin-left: 15px;
    }
    p {
      margin-top: 12px;
    }
  }
  .p-day {
    margin-top: -8px !important;
    @media (max-width: 756px) {
      display: none;
    }
  }
  .p-day-res {
    margin-top: -8px !important;
    @media (max-width: 350px) {
      font-size: 15px;
    }
  }

  .bloco-p {
    display: none;
    @media (max-width: 756px) {
      display: flex;
      flex-direction: column;
    }
  }

  .blue-data {
    background-color: #00faff !important;
    border: 3px solid black;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    top: 10px;
    left: 10px;
  }
  .ativo-data {
    background-color: #ff006f !important;
    border: 3px solid black;
    color: white !important;
    padding: 10px;
    height: 40px;
    width: auto;
    @media (max-width: 756px) {
      height: 75px !important;
    }
    @media (max-width: 350px) {
      height: 65px !important;
    }
  }
  .blue {
    background-color: #00faff !important;
    border: 3px solid black;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    top: 10px;
    left: 10px;
  }
  .ativo {
    background-color: #ff006f !important;
    border: 3px solid black;
    color: white !important;
    // padding: 10px;
    height: 40px;
    width: auto;
  }
  .branco {
    background-color: white;
    border: 3px solid black;
    color: black;
    padding: 10px;
    height: 40px;
    width: auto;
    @media (max-width: 756px) {
      height: 75px !important;
    }
    @media (max-width: 350px) {
      height: 65px !important;
    }
  }
  .branco2 {
    background-color: white;
    border: 3px solid black;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    top: 10px;
    left: 10px;
  }
  .alinhar {
    flex-wrap: wrap;
    margin-top: 20px;
    .palestras {
      margin-bottom: 20px;
      p {
        color: black;
      }
      .background-palestras {
        box-sizing: border-box;
        cursor: pointer;
        height: 400px;
        position: relative;
        overflow: hidden;
        width: 350px;
        @media (max-width: 1200px) {
          padding: 60px 25px 40px 25px;
          width: 100%;
          height: 410px;
        }
        @media (max-width: 996px) {
          padding: 60px 20px 40px 20px;
          width: 325px;
          height: 100%;
        }
        @media (max-width: 400px) {
          width: 100%;
          padding: 40px 10px;
        }
      }
      .alinhar-botoes {
        margin-top: 10px;
        height: 60px;
        @media (max-width: 996px) {
          position: relative;
          height: 75px;
        }
      }
      .trilha-palestrante {
        align-items: center;
        border: 2px solid black;
        display: flex;
        font-weight: 800;
        font-size: 13px;
        justify-content: center;
        height: 30px;
        width: 130px;
        margin-top: -44px;
        margin-right: 10px;
        margin-left: 10px;
        @media (max-width: 996px) {
          margin-right: 10px;
          margin-left: 10px;
          width: 110px;
          font-size: 11px;
          line-height: 11px;
          padding-inline: 2px;
        }
        @media (max-width: 350px) {
          width: 95px;
          font-size: 9px;
        }
        @media (max-width: 330px) {
          width: 87px;
          font-size: 8px;
        }
      }
      .azul-palestrante1 {
        background-color: #00faff;
        border: 2px solid black;
        height: 30px;
        width: 130px;
        margin-left: 14px;
        margin-bottom: 10px;
        @media (max-width: 996px) {
          width: 110px;
        }
        @media (max-width: 350px) {
          width: 95px;
        }
        @media (max-width: 330px) {
          width: 87px;
        }
      }
      .azul-palestrante2 {
        background-color: #00faff;
        border: 2px solid black;
        position: absolute;
        bottom: 15px;
        left: 20px;
        height: 30px;
        width: 170px;
        @media (max-width: 996px) {
          left: 5px;
          bottom: 0px;
        }
      }
    }
  }
  .info-palestrante {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    height: 100%;
    p {
      color: black;
      font-family: "Montserrat", sans-serif;
      font-size: 14px;
      margin-left: 20px;
      line-height: 14px;
    }
    .destaque {
      font-weight: 600;
      font-style: italic;
      font-size: 12px;
      line-height: 12px;
      margin-top: -7px;
      @media (max-width: 400px) {
        font-size: 10px !important;
      }
    }
    .destaque-rosa {
      font-weight: 800;
    }
    .data-hora {
      font-weight: 400;
      color: #ff006f !important;
    }
  }
  .minibio {
    color: black;
    font-family: "Montserrat", sans-serif;
    font-size: 12px !important;
    line-height: 12px;
    margin-top: -7px;
  }
  .img-palestrante {
    border: 2px solid black;
    height: 110px;
    position: relative;
    width: 130px;
    @media (max-width: 575px) {
      height: 90px;
      width: 110px;
    }
  }
  .img-azul {
    background-color: #00faff;
    border: 2px solid black;
    height: 110px;
    position: absolute;
    top: 8px;
    left: 8px;
    width: 130px;
    @media (max-width: 575px) {
      height: 90px;
      width: 110px;
    }
  }
  .img-azul-small {
    background-color: #00faff;
    border: 2px solid black;
    height: 35px;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 40px;
    @media (max-width: 575px) {
      height: 35px;
      width: 40px;
    }
  }
  .img-palestrante-small {
    border: 2px solid black;
    height: 34px;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 40px;
    @media (max-width: 575px) {
      height: 35px;
      width: 40px;
    }
  }
  .trilha-palestrante-small {
    align-items: center;
    border: 2px solid black;
    bottom: 10px;
    display: flex;
    font-weight: 800;
    font-size: 15px;
    justify-content: center;
    height: 30px;
    position: absolute;
    width: 170px;
    @media (max-width: 996px) {
      bottom: 45px;
    }
  }
  .azul-palestrante1-small {
    background-color: #00faff;
    border: 2px solid black;
    position: absolute;
    bottom: 15px;
    left: 20px;
    height: 30px;
    width: 170px;
    @media (max-width: 996px) {
      left: 5px;
      bottom: 40px;
    }
  }
  .nova_area_palestrantes {
    display: flex;
    flex-direction: row;
  }
  .image_area {
    width: 30px;
    @media (max-width: 996px) {
      width: 40px;
    }
  }
  .titulo_painel {
    color: black;
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 0px;
    margin-top: 10px;
    margin-bottom: 0px;
    text-align: left;
    @media (max-width: 991px) {
      margin-bottom: 10px;
    }
  }
  .info-palestrante-small {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0px;
    height: 100%;
    width: calc(100% - 40px);
    line-height: 1;
    p {
      color: black;
      font-family: "Montserrat", sans-serif;
      font-size: 12px;
      margin-bottom: 3px;
      margin-left: 10px;
      margin-top: -15px;
    }
    .destaque {
      font-weight: 600;
      font-style: italic;
      margin-top: 0px;
      font-size: 12px;
      line-height: 12px;
      @media (max-width: 400px) {
        font-size: 12px !important;
      }
    }
    .destaque-rosa {
      font-weight: 800;
    }
    .data-hora {
      font-weight: 400;
      color: #ff006f !important;
    }
  }
  .data-hora-small {
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #ff006f !important;
    margin-bottom: 5px;
  }
  .modal-preto-prog {
    background-color: rgba(0, 0, 0, 0.53);
    cursor: pointer;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .modal-branco-prog {
    background-color: white;
    border: 3px solid black;
    border-radius: 0px !important;
    width: 600px;
    height: 500px;
    padding: 40px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -300px;
    margin-top: -250px;
    z-index: 3;
    overflow: auto;
    @media (max-width: 775px) {
      width: 400px;
      margin-left: -200px;
    }
    @media (max-width: 450px) {
      width: 350px;
      margin-left: -175px;
    }
    @media (max-width: 350px) {
      width: 300px;
      margin-left: -150px;
    }

    .fa {
      font-size: 25px;
      color: #ff006f;
      cursor: pointer;
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
  .modal-azul-prog {
    background-color: #ff006f;
    border: 3px solid black;
    border-radius: 0px !important;
    width: 600px;
    height: 500px;
    position: fixed;
    top: 52%;
    left: 51%;
    margin-left: -300px;
    margin-top: -250px;
    z-index: 3;
    @media (max-width: 775px) {
      width: 400px;
      margin-left: -200px;
      top: 53%;
      left: 52%;
    }
    @media (max-width: 450px) {
      width: 350px;
      margin-left: -175px;
      top: 51%;
      left: 52%;
    }
    @media (max-width: 350px) {
      width: 300px;
      margin-left: -150px;
    }
  }
  .res-info {
    margin-top: 40px !important;
    @media (max-width: 450px) {
      margin-left: -20px;
    }
  }
  .modal-img {
    height: 161px !important;
    width: 190px !important;
    margin-bottom: 20px;
    @media (max-width: 775px) {
      height: 161px !important;
      width: 190px !important;
    }
  }
  .modal-img-azul-dois {
    @media (max-width: 450px) {
      top: 5px;
      left: 83px;
    }
    @media (max-width: 350px) {
      left: 45px;
    }
  }
  .modal-img-azul {
    @media (max-width: 450px) {
      left: 45px;
    }
    @media (max-width: 350px) {
      left: 20px;
    }
  }
  .info-modal {
    display: flex;
    flex-direction: row;
    @media (max-width: 450px) {
      flex-direction: column;
    }
  }
  .descricao_modal {
    margin-top: 20px;
    h5 {
      font-weight: bold;
      font-size: 18px;
      font-family: "Montserrat";
    }
    p {
      font-size: 14px;
      font-family: "Montserrat";
    }
  }
}
.trilhaPlenaria {
  flex-direction: row;
  position: relative;
  margin-top: 30px;
  @media (max-width: 450px) {
    flex-direction: column;
  }
  .azul-palestrante-modal {
    background-color: #00faff;
    border: 2px solid black;
    position: absolute;
    bottom: -5px;
    left: 72px;
    height: 30px;
    width: 170px;
    @media (max-width: 775px) {
      width: 145px;
      left: 7px;
    }
    @media (max-width: 450px) {
      width: 170px;
      left: 53px;
      bottom: 65px;
    }
    @media (max-width: 350px) {
      left: 28px;
    }
  }
  .azul-palestrante2-modal {
    background-color: #00faff;
    border: 2px solid black;
    position: absolute;
    bottom: -5px;
    right: 62px;
    height: 30px;
    width: 170px;
    @media (max-width: 775px) {
      width: 145px;
      right: -5px;
    }
    @media (max-width: 450px) {
      width: 170px;
      left: 53px;
      bottom: 15px;
    }
    @media (max-width: 350px) {
      left: 28px;
    }
  }
  .trilha-palestrante-modal {
    align-items: center;
    border: 2px solid black;
    color: black;
    display: flex;
    font-weight: 800;
    font-size: 15px;
    justify-content: center;
    height: 30px;
    width: 170px;
    margin-right: 20px;
    z-index: 2;
    @media (max-width: 775px) {
      margin-right: 10px;
    }
    @media (max-width: 450px) {
      margin-right: 0px;
      margin-bottom: 20px;
    }
  }
  .plenaria-palestrante-modal {
    align-items: center;
    background-color: #0047ff;
    border: 2px solid black;
    color: white;
    display: flex;
    font-weight: 800;
    font-size: 15px;
    justify-content: center;
    height: 30px;
    width: 170px;
    margin-left: 20px;
    z-index: 2;
    @media (max-width: 775px) {
      margin-left: 10px;
    }
    @media (max-width: 450px) {
      margin-left: 0px;
      margin-bottom: 20px;
    }
  }
}
.modal-linkedin {
  margin-left: 20px;
}
.nome {
  font-size: 18px !important;
  color: #ff006f !important;
}
.modaldois-img {
  height: 85px !important;
  width: 100px !important;
  @media (max-width: 450px) {
    margin-bottom: 20px;
  }
}
.info-modalDois {
  margin-bottom: 10px;
}
.data-hora {
  font-weight: 400;
  color: #ff006f !important;
}
.azul-palestrante1-modal1 {
  background-color: #00faff;
  border: 2px solid black;
  height: 30px;
  width: 200px;
  margin-left: 5px;
  margin-bottom: 10px;
  @media (max-width: 380px) {
    width: 110px;
  }
}
.trilha-palestrante-modal1 {
  align-items: center;
  border: 2px solid black;
  display: flex;
  font-weight: 800;
  font-size: 16px;
  justify-content: center;
  height: 30px;
  width: 200px;
  margin-top: -44px;
  @media (max-width: 400px) {
    width: 110px;
    font-size: 11px;
  }
}
</style>
